"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants_1 = require("../GameConstants");
var GameVars_1 = require("../GameVars");
var Card_1 = require("./cards/Card");
var DealPile_1 = require("./cards/DealPile");
var Pile_1 = require("./cards/Pile");
var Board = /** @class */ (function (_super) {
    __extends(Board, _super);
    function Board(game) {
        var _this = _super.call(this, game, null, "board") || this;
        _this.cards = [];
        _this.collidingPiles = [];
        _this.collidingCards = [];
        GameConstants_1.GameConstants.PILES_Y = GameConstants_1.GameConstants.DEALPILE_Y + 210 * GameVars_1.GameVars.scaleY;
        Pile_1.Pile.CARDS_OFFSET = 40 * GameVars_1.GameVars.scaleY;
        Card_1.Card.tweening = false;
        _this.dealPile = new DealPile_1.DealPile(_this.game);
        _this.dealPile.setPosition(658, GameConstants_1.GameConstants.DEALPILE_Y - (80 * GameVars_1.GameVars.scaleY));
        _this.add(_this.dealPile);
        _this.piles = [];
        for (var i = 0; i < 4; i++) {
            var foundationPile = new Pile_1.Pile(_this.game, 4 + 53 + 109 * i, GameConstants_1.GameConstants.DEALPILE_Y, i);
            foundationPile.foundation = true;
            _this.piles.push(foundationPile);
            _this.add(foundationPile);
        }
        for (var i = 0; i < 7; i++) {
            var pile = new Pile_1.Pile(_this.game, 4 + 53 + 109 * i, GameConstants_1.GameConstants.PILES_Y, i);
            _this.piles.push(pile);
            _this.add(pile);
        }
        _this.shadow = new Phaser.Image(_this.game, 0, 0, "texture_atlas_2", "card_shadow.png");
        _this.shadow.anchor.set(.45, 0);
        _this.shadow.visible = false;
        _this.add(_this.shadow);
        return _this;
    }
    Board.prototype.shuffle = function () {
        this.dealPile.shuffle();
    };
    Board.prototype.setCardsFromServer = function () {
        // foundation piles
        for (var i = 0; i < 4; i++) {
            var pileData_1 = { cards: [], flipped: 0 };
            for (var j = 0; j < this.piles[i].piledCards.length; j++) {
                pileData_1.cards.push(this.piles[i].piledCards[j].cardValue);
            }
            GameVars_1.GameVars.pilesData.push(pileData_1);
        }
        // piles
        for (var i = 4; i < 11; i++) {
            var pileData_2 = { cards: [], flipped: 0 };
            var firstFliped = false;
            for (var j = 0; j < this.piles[i].piledCards.length; j++) {
                pileData_2.cards.push(this.piles[i].piledCards[j].cardValue);
                if (this.piles[i].piledCards[j].turned && !firstFliped) {
                    firstFliped = true;
                    pileData_2.flipped = j;
                }
            }
            GameVars_1.GameVars.pilesData.push(pileData_2);
        }
        var pileDataAux = { cards: [], flipped: 0 };
        for (var i = 0; i < this.dealPile.piledCardsAux.length; i++) {
            pileDataAux.cards.push(this.dealPile.piledCardsAux[i].cardValue);
        }
        GameVars_1.GameVars.pilesData.push(pileDataAux);
        var pileData = { cards: [], flipped: 0 };
        for (var i = 0; i < this.dealPile.piledCards.length; i++) {
            pileData.cards.push(this.dealPile.piledCards[i].cardValue);
        }
        pileData.flipped = pileData.cards.length;
        GameVars_1.GameVars.pilesData.push(pileData);
    };
    Board.prototype.putCards = function () {
        for (var i = 0; i < GameVars_1.GameVars.cards.length; i++) {
            var testCard = new Card_1.Card(this.game, 658 + 53, GameConstants_1.GameConstants.DEALPILE_Y, GameVars_1.GameVars.cards[i]);
            this.add(testCard);
            this.cards.push(testCard);
        }
    };
    Board.prototype.checkCollisions = function () {
        // para vaciar el array
        this.collidingPiles.length = 0;
        this.collidingCards.length = 0;
        for (var i = 0; i < this.piles.length; i++) {
            this.game.physics.arcade.overlap(GameVars_1.GameVars.draggedCard, this.piles[i], this.collisionWithPile, null, this);
        }
        for (var i = 0; i < this.cards.length; i++) {
            // no es necesario mirar colisiones con las cartas arrastradas
            if (GameVars_1.GameVars.draggedCard.attachedCards.indexOf(this.cards[i]) < 0) {
                this.game.physics.arcade.overlap(GameVars_1.GameVars.draggedCard, this.cards[i], this.collisionWithOtherCard, null, this);
            }
        }
        return { collidingPiles: this.collidingPiles, collidingCards: this.collidingCards };
    };
    Board.prototype.newSmoke = function (x, y) {
        var smoke = new Phaser.Image(this.game, x, y - (50 * GameVars_1.GameVars.scaleY), "texture_atlas_4", "smoke0001.png");
        smoke.anchor.set(.5);
        smoke.scale.set(2, 2 * GameVars_1.GameVars.scaleY);
        this.add(smoke);
        smoke.animations.add("smoke", Phaser.Animation.generateFrameNames("smoke", 1, 40, ".png", 4));
        smoke.play("smoke", 24);
        smoke.animations.currentAnim.onComplete.add(function () {
            smoke.destroy();
        }, this);
    };
    Board.prototype.collisionWithPile = function (card, pile) {
        this.collidingPiles.push(pile);
    };
    Board.prototype.collisionWithOtherCard = function (cardA, cardB) {
        this.collidingCards.push(cardB);
    };
    return Board;
}(Phaser.Group));
exports.Board = Board;
